import API from 'shared/constants/api';
import { getAdsContext } from 'shared/helpers/adsAndMetrics';
import { setHomeCounters } from 'shared/actions/homeSpecialCars';
import { setJournalNews, setVideoTopics } from 'shared/actions/journal';
import queryString from 'query-string';

const CURRENT_TRANSPORT_ID = 1;
const PER_PAGE = 19;

async function action({ fetch, baseUrl, path, query, store, params }) {
  const url = `${baseUrl}${path}`.replace('//', '/');
  const page = parseInt(query.page || 1, 10);
  const { tag } = query;
  const { journal: { rubrics }, locale: language } = store.getState().globals;
  const { rubricSeoSlug = rubrics[0].seo_slug } = params;
  const currentRubric = rubrics.find(rubric => rubric.seo_slug === rubricSeoSlug);

  if (!currentRubric) {
    // Map to the next sibling route
    return null;
  }

  let makes = [];
  if (store.getState().homeCounters && store.getState().homeCounters.all) {
    makes = store.getState().homeCounters.all;
  } else {
    await fetch(
      `${API.ADVERT.MAKES_COUNT}?${queryString.stringify({
        transport: CURRENT_TRANSPORT_ID,
      })}`,
    )
      .then(r => r.ok && r.json())
      .then(resp => {
        makes = resp;
        store.dispatch(setHomeCounters({ all: resp }));
      });
  }
  const [newsResponse, tags, videoTopics] = await Promise.all([
    fetch(
      API.JOURNAL.LIST({
        tag,
        page,
        perPage: PER_PAGE,
        rubric: [currentRubric.slug],
        language,
      }),
    ),
    fetch(API.JOURNAL.TAGS({ rubric: currentRubric.slug, language })).then(r => r.json()),
    fetch(API.JOURNAL.VIDEO_TOPICS({ language })).then(r => r.json()),
  ]);

  if (newsResponse.status === 404) {
    return null;
  }

  const newsData = await newsResponse.json();
  const news = newsData.results;
  const pageCount = Math.ceil(newsData.count / PER_PAGE);

  const { location } = store.getState().globals;
  const targetingArguments = getAdsContext({
    location,
    page,
    rubric: tag,
  });
  store.dispatch(setJournalNews(news));
  store.dispatch(setVideoTopics(videoTopics || []));

  return {
    makes,
    news,
    rubrics,
    currentRubric,
    tags,
    page,
    pageCount,
    url,
    query,
    tag,
    targetingArguments,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/shared/routes/journal/news/index.js